// extracted by mini-css-extract-plugin
export default {"productGallery":"uJ-z","inQuickShop":"vJ-z"};